<template>
	<div class="head-serch">
		<el-form
			class="form"
			ref="searchFormDom"
			:model="searchForm"
			label-width="100px"
			@submit.native.prevent
			@keyup.enter.native="searchHandler"
		>
			<el-form-item label="标准型号">
				<el-input v-model="searchForm.deviceModel" placeholder="请输入标准型号" />
			</el-form-item>
		</el-form>
		<el-button class="filter-item" size="mini" type="success" icon="el-icon-search" @click="searchHandler">搜索</el-button>
	</div>
</template>

<script>
export default {
	data() {
		return {
			searchForm: {
				deviceModel: ''
			}
		};
	},
	created() {},
	methods: {
		searchHandler() {
			this.$emit('searchForm', this.searchForm);
		}
	}
};
</script>

<style>
.form {
	display: flex;
}
</style>
